import { memo, useRef, useState, useEffect } from 'react';

import FilterConditionItem from '@lcsc-ui/components/FilterConditionItem';
import { isEqual } from 'lodash-es';

import '@lcsc-ui/components/FilterCondition/style.less';

const getLetterList = (arr) => {
  const result = [];
  (arr || []).forEach((item) => {
    if (item.firstLetter && !result.includes(item.firstLetter)) {
      result.push(item.firstLetter);
    }
  });
  return result.sort();
};

const Index = (props) => {
  const catalogRef = useRef(null);
  const brandRef = useRef(null);

  const [catalogData, setCatalogData] = useState({
    name: '类目',
    value: 'value',
    label: 'label',
    list: props?.catalogFilters,
    letterList: getLetterList(props?.catalogFilters),
    showInputCondition: false,
  });

  const [brandData, setBrandData] = useState({
    name: '品牌',
    value: 'value',
    label: 'label',
    list: props?.brandFilters,
    letterList: getLetterList(props?.brandFilters),
    showInputCondition: false,
  });

  useEffect(() => {
    if (!isEqual(catalogData?.list, props?.catalogFilters)) {
      setCatalogData({
        ...catalogData,
        list: props?.catalogFilters,
        letterList: getLetterList(props?.catalogFilters),
      });
    }
  }, [catalogData, props?.catalogFilters]);

  useEffect(() => {
    if (!isEqual(brandData?.list, props?.brandFilters)) {
      setBrandData({
        ...brandData,
        list: props?.brandFilters,
        letterList: getLetterList(props?.brandFilters),
      });
    }
  }, [brandData, props?.brandFilters]);

  const onlyOpenOneShowMore = (name, value) => {
    if (!value) return;
    if (name === '类目') {
      brandRef?.current?.resetInitStatus();
    } else if (name === '品牌') {
      catalogRef?.current?.resetInitStatus();
    }
  };

  const changeSendParams = (selectDataList, name) => {
    if (name === '类目') {
      props?.changeSendSearchParams({
        catalogIdFilter: selectDataList.map((item) => item.value).join('$'),
        currentPage: 1,
      });
    } else if (name === '品牌') {
      props?.changeSendSearchParams({
        brandIdFilter: selectDataList.map((item) => item.value).join('$'),
        currentPage: 1,
      });
    }
  };

  return (
    <ul className={'m-auto  px-[20px] pt-[17px]'}>
      <li className={'border-b border-solid border-[#EFEFEF]'}>
        <FilterConditionItem
          data={catalogData}
          ref={catalogRef}
          onlyOpenOneShowMore={onlyOpenOneShowMore}
          changeSendParams={changeSendParams}
          selectValue={props?.sendSearchParams?.catalogIdFilter}
          queryParam={{
            name: 'queryProductTypeCode',
            code: 'value',
          }}
        />
      </li>
      <li className={'border-b border-solid border-[#EFEFEF] pt-[10px]'}>
        <FilterConditionItem
          data={brandData}
          ref={brandRef}
          onlyOpenOneShowMore={onlyOpenOneShowMore}
          changeSendParams={changeSendParams}
          selectValue={props?.sendSearchParams?.brandIdFilter}
          queryParam={{
            name: 'queryProductGradePlateId',
            code: 'value',
          }}
        />
      </li>
    </ul>
  );
};

Index.displayName = 'Index';

export default memo(Index);
